import commaNumber from 'comma-number'

import customConfig from 'customConfig'

const toLower = (text) => {
  return text?.toLowerCase()
}

const toDashCase = (text) => {
  return toLower(text?.replace(/\s+/g, '-'))
}

const isUrlPatternMatching = (url, part) => {
  if (!url) {
    return ''
  }
  return toLower(url).indexOf(toLower(part)) !== -1
}

const removeTicks = (str) => {
  return str
    .split('')
    .filter((el) => el !== customConfig.currencyDelimiter)
    .join('')
}

const formatTicks = (num) => {
  if (num === undefined) {
    return ''
  }
  return commaNumber(num, customConfig.currencyDelimiter)
}

const snakeCaseToDashCase = (text) => {
  return text?.replace(/_+/g, '-')
}

const removeFirstSlash = (str) => {
  return str.startsWith('/') ? str.slice(1) : str
}

const titleCase = (str) => {
  return String(str)
    .split(' ')
    .map((word) =>
      word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : ''
    )
    .join(' ')
}

const toUpper = (text) => {
  return text ? text.toUpperCase() : ''
}

function extractEmailFromUrl(searchString) {
  const searchDropFirstChar = searchString.slice(1, -1)
  const options = searchDropFirstChar.split('&')

  return options.reduce((curr, next) => {
    const [value, key] = next.split('=')
    if (value === 'email') {
      return key
    } else {
      return curr
    }
  }, '')
}

const extractCodeOrInputText = (text) => {
  try {
    const url = new URL(text)
    return url.searchParams.get('code')
  } catch (e) {
    return text
  }
}

const toLowerCamelCase = (s) => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace('-', '').replace('_', '')
  })
}

const stringToBool = (label) => {
  return label === 'true'
}

const equalsIgnoreCase = (str1, str2) => {
  if (typeof str1 !== 'string' || typeof str2 !== 'string') {
    return false
  }
  return str1.toLowerCase() === str2.toLowerCase()
}

export {
  toLower,
  toDashCase,
  isUrlPatternMatching,
  formatTicks,
  removeTicks,
  snakeCaseToDashCase,
  removeFirstSlash,
  titleCase,
  toUpper,
  extractEmailFromUrl,
  extractCodeOrInputText,
  toLowerCamelCase,
  stringToBool,
  equalsIgnoreCase
}
